<template>
  <div class="page-content--body">
    <div class="page-content--body-right">
      <div class="map">
        <div class="map-settings">
          <v-tabs
            v-model="storeType"
            class="stout--tabs"
            show-arrows
            next-icon="mdi-chevron-right"
            prev-icon="mdi-chevron-left"
          >
            <v-tab href="#retail_store">Розничный магазин</v-tab>
            <v-tab href="#internet_store">Интернет-магазин</v-tab>
          </v-tabs>
          <div class="map-settings--search">
            <v-form
              ref="form"
              autocomplete="off"
              class="auth-form"
              lazy-validation
            >
              <div class="w-100 indent">
                <div class="input-label">Город</div>
                <v-autocomplete
                  v-model="selectedCity"
                  :items="cities"
                  :loading="citiesAutocompleteIsLoading"
                  :search-input.sync="citiesSearch"
                  clearable
                  dense
                  hide-details
                  hide-no-data
                  item-text="title"
                  item-value="id"
                  outlined
                  required
                  @keyup.enter="loadDistributors"
                  @change="loadDistributors"
                ></v-autocomplete>
              </div>

              <v-btn
                class="btn-blue mb-0 ml-4"
                color="primary"
                @click="loadDistributors"
              >
                Найти
              </v-btn>
            </v-form>
          </div>
        </div>

        <div class="map-content">
          <div class="map-content--list">
            <div
              v-for="distributor in distributors"
              class="map-content--list-point"
              :class="[activeMarket === distributor.id ? 'is-active' : '']"
              @click="onMarketClick(distributor)"
            >
              <div class="map-content--list-point-head">
                {{ distributor.name }}
              </div>
              <div
                class="map-content--list-point-body"
              >
                <div class="map-content--list-point-body-line">
                  <div class="map-content--list-point-body-line--ico">
                    <img alt="" src="@/assets/images/map-ico-time.svg"/>
                  </div>
                  <div class="map-content--list-point-body-line--text">
                    <span v-if="distributor.schedule">{{ distributor.schedule }}</span>
                    <span class="map-content--list-point-body-line--text--no-data" v-else>Нет данных</span>
                  </div>
                </div>
                <div
                  class="map-content--list-point-body-line"
                >
                  <div class="map-content--list-point-body-line--ico">
                    <img alt="" src="@/assets/images/map-ico-phone.svg"/>
                  </div>
                  <div class="map-content--list-point-body-line--text">
                    <div v-if="distributor.phone.length">
                      <a
                        v-for="phone in getPhones(distributor)"
                        :href="'tel:' + phone"
                      >{{ phone }}</a
                      >
                    </div>
                    <span v-else class="map-content--list-point-body-line--text--no-data">Нет данных</span>
                  </div>
                </div>
                <div
                  class="map-content--list-point-body-line"
                >
                  <div class="map-content--list-point-body-line--ico">
                    <img alt="" src="@/assets/images/map-ico-site.svg"/>
                  </div>
                  <div class="map-content--list-point-body-line--text">
                    <a v-if="distributor.url" :href="distributor.url" target="_blank">{{
                        distributor.url
                      }}</a>
                    <span class="map-content--list-point-body-line--text--no-data" v-else>Нет данных</span>
                  </div>
                </div>
                <div
                  class="map-content--list-point-body-line"
                >
                  <div class="map-content--list-point-body-line--ico">
                    <img alt="" src="@/assets/images/map-ico-address.svg"/>
                  </div>
                  <div class="map-content--list-point-body-line--text">
                    <span v-if="distributor.address">{{ distributor.address }}</span>
                    <span class="map-content--list-point-body-line--text--no-data" v-else>Нет данных</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="map-content--map">
            <yandex-map :coords="coords" :zoom="10" style="height: 100%">
              <ymap-marker
                v-for="distributor in distributors"
                :key="distributor.id"
                :coords="[
                  parseFloat(distributor.map_latitude),
                  parseFloat(distributor.map_longitude),
                ]"
                :icon="{
                  color: activeMarket === distributor.id ? 'red' : 'blue',
                }"
                :marker-id="distributor.id.toString()"
                :hint-content="distributor.name"
                cluster-name="markets"
                @click="onMarkerClick(distributor)"
              ></ymap-marker>
            </yandex-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Markets',
  data() {
    return {
      // Тип магазина
      storeType: 'internet_store',
      // Москва
      coords: [55.75222, 37.61556],
      // Выбранный в автокомплите город (идентификатор)
      selectedCity: null,
      // Лоадер для автокомплита
      citiesAutocompleteIsLoading: false,
      // Список городов для автокомплита
      cities: [],
      // Введённая пользователем строка в автокомплите выбора города
      citiesSearch: null,
      // Магазины
      distributors: [],
      // Выбранный в данный момент магазин
      activeMarket: null,
    };
  },
  mounted() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.coords = [position.coords.latitude, position.coords.longitude];
    });
    this.$store.dispatch('SetTitle', 'Магазины');
    if (this.user.city_id !== null && this.user.city_id !== undefined) {
      this.loadCities(this.user.city?.title ?? '');
      this.selectedCity = this.user.city_id;
    }
    this.loadDistributors();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    storeType() {
      this.loadDistributors();
    },
    user(value) {
      if (value.city_id !== null && value.city_id !== undefined) {
        this.selectedCity = value.city_id;
      }
    },
    citiesSearch(value) {
      this.loadCities(value);
    },
  },

  methods: {
    loadCities(pattern) {
      this.citiesAutocompleteIsLoading = true;
      this.$store.getters.axl
        .post('/location/api/cities/list', { term: pattern })
        .then((response) => {
          this.cities = response.data.cities;
        })
        .finally(() => {
          this.citiesAutocompleteIsLoading = false;
        });
    },
    // Загрузить список магазинов
    loadDistributors() {
      this.distributors = [];
      this.$store.getters.axl
        .post('/profiles/api/distributors', {
          city_id: this.selectedCity,
          type: this.storeType,
        })
        .then((response) => {
          this.distributors = response.data.data;
          // Если выбрали город, то центрируем на нём карту
          if (this.selectedCity && this.distributors.length) {
            this.coords = [
              parseFloat(this.distributors[0].map_latitude),
              parseFloat(this.distributors[0].map_longitude),
            ];
          }
        });
    },
    // Получить список телефонов магазина из строки
    getPhones(distributor) {
      if (!distributor.phone) {
        return '';
      }
      const phones = distributor.phone.split(';');
      phones.forEach(el => el.trim());
      return phones;
    },
    // Получить координаты магазина (в формате для карты)
    getMarketCoords(distributor) {
      return [parseFloat(distributor.map_latitude), distributor.map_longitude];
    },
    // Действия по клику на магазин в списке слева
    onMarketClick(distributor) {
      this.activeMarket = distributor.id;
      this.coords = [
        parseFloat(distributor.map_latitude),
        distributor.map_longitude,
      ];
    },
    // Действия по клику на маркер на карте
    onMarkerClick(distributor) {
      this.activeMarket = distributor.id;
      this.$nextTick(() => {
        const containerElements = document.getElementsByClassName('map-content--list');
        if (containerElements) {
          const container = containerElements.item(0);
          let activeChild = null;
          for (let i = 0; i < container.children.length; i += 1) {
            const child = container.children.item(i);
            if (child.classList.contains('is-active')) {
              activeChild = child;
              break;
            }
          }
          if (activeChild) {
            const containerOffset = container.offsetTop;
            const childOffset = activeChild.offsetTop;
            container.scrollTop = childOffset - containerOffset - activeChild.clientHeight;
          }
        }
      });
    },
  },

};
</script>

<style lang="scss" src="./markets.scss"/>
